<template>
    <div class="tab-visibility">
        <div class="header">
            <div class="title">{{ $t("mail_integration_detail.visibility") }}</div>
            <div class="subtitle">{{ $t("message.manageVisibilityDesc") }}</div>
        </div>

        <VisibilityChanger v-model="clone.visibility" :show-title="false" />
    </div>
</template>

<script>
import Vue from "vue";
import VisibilityChanger from "../../../WhatsappV1/VisibilityChanger.vue";
import _ from "lodash";

export default Vue.extend({
    name: "Visibility",
    components: { VisibilityChanger },
    props: {
        value: {
            required: true,
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
            isUpdatingFromParent: false,
        };
    },
    watch: {
        "clone.visibility": {
            handler: function (val, oldVal) {
                if (this.isUpdatingFromParent) return;
                if (val && oldVal) {
                    const isChanged = !_.isEqual(val, oldVal);
                    if (isChanged) {
                        this.$emit("input", this.clone);
                    }
                }
            },
            deep: true,
        },
        value: {
            handler: function (val) {
                const isChanged = !_.isEqual(val, this.clone);
                if (isChanged) {
                    this.isUpdatingFromParent = true;
                    this.clone = _.cloneDeep(val);
                    this.$nextTick(() => {
                        this.isUpdatingFromParent = false;
                    });
                }
            },
            deep: true,
        },
    },
});
</script>

<style scoped lang="scss">
.tab-visibility {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;

    .header {
        display: flex;
        justify-content: space-between;
        padding-bottom: 10px;
        border-bottom: 1px solid var(--color-border-default);

        .title {
            font-size: 18px;
            font-weight: 700;
            color: var(--color-text-strong-default);
        }

        .subtitle {
            font-size: 14px;
            color: var(--color-text-strong-default);
        }
    }
}
</style>
